import React from 'react';
import { badListe, bilListe, genereltListe, kjokkenListe, langAvstandListe } from "./huskelistepunkter";
import style from "./huskeliste.module.css";

const Huskeliste = () => {

    function fjernMarkeringer() {
        const checkboxes = document.getElementsByName('huskelistepunkt') as NodeListOf<HTMLInputElement>;
        checkboxes.forEach(checkbox => checkbox.checked = false);
    }

    const kategorier = [
        { ikon: "🧑‍🍳", navn: "Kjøkken", punkter: kjokkenListe },
        { ikon: "🛀", navn: "Bad", punkter: badListe },
        { ikon: "🚗", navn: "Bil", punkter: bilListe },
        { ikon: "📝", navn: "Til slutt", punkter: genereltListe, fotnote: "* Man skal i utgangspunktet vaske sengetøyet selv, men hvis inntil 4 sett er det mulig å avtale med den som kommer etter. Man kan avtale med Raquel at hun kan vaske sengetøy m.m. Hun vil ha 15 € per maskin. Brukt sengetøy og håndklær henges opp i casinettoen slik at de ikke ligger fuktige og mugner." },
        { ikon: "🗓️", navn: "Hvis to uker eller mer til neste besøk", punkter: langAvstandListe },
    ];

    return (
        <div>
            <div className="page">
                <h1 className="topHeader">HUSKELISTE</h1>
            </div>
            <div className="underPage">
                <div className={style.wrapper}>
                    <div className={style.avreiseSeksjon}>
                        <div className={style.avreiseHeader}>
                            <h2>Før ankomst</h2>
                        </div>
                        <div className={style.kategoriKort}>
                            <div className={style.punkter}>
                                <label className="checkmarkLabel">
                                    <input type="checkbox" name="huskelistepunkt" className="checkbox" />
                                    Manuel må varsles før du kommer, slik at huset er vasket og hage og basseng er i orden. Manuel steller hagen og bassenget vanligvis på lørdager. Fordi det er mye støv vaskes det før nestemann kommer.
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className={style.avreiseSeksjon}>
                        <div className={style.avreiseHeader}>
                            <h2>Ved ankomst</h2>
                        </div>
                        <div className={style.kategoriKort}>
                            <div className={style.punkter}>
                                <label className="checkmarkLabel">
                                    <input type="checkbox" name="huskelistepunkt" className="checkbox" />
                                    Vannlåsene tørker ut, fyll vann i slukene på badene og på takterrassen. Gjør det igjen dersom lukt.
                                </label>
                                <label className="checkmarkLabel">
                                    <input type="checkbox" name="huskelistepunkt" className="checkbox" />
                                    Sjekk alltid at vannet renner ned i sluket før man dusjer! Hvis gjester — sjekk dette før de tar dusjen i bruk!
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className={style.avreiseSeksjon}>
                        <div className={style.avreiseHeader}>
                            <h2>Ved avreise</h2>
                            <button
                                type="button"
                                id="unselect-all"
                                className={style.nullstillKnapp}
                                onClick={fjernMarkeringer}
                            >
                                Nullstill markeringer
                            </button>
                        </div>

                        {kategorier.map((kategori) => (
                            <React.Fragment key={kategori.navn}>
                                <div className={style.kategoriKort}>
                                    <h3 className={style.kategoriTittel}>
                                        <span className={style.kategoriIkon}>{kategori.ikon}</span>
                                        {kategori.navn}
                                    </h3>
                                    <div className={style.punkter}>
                                        {kategori.punkter.map((item, index) => (
                                            <label key={index} className="checkmarkLabel">
                                                <input type="checkbox" name="huskelistepunkt" className="checkbox" />
                                                {item}
                                            </label>
                                        ))}
                                    </div>
                                </div>
                                {kategori.fotnote && (
                                    <p className={style.fotnote}>{kategori.fotnote}</p>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
                <div className={style.sideKolonne}>
                    <div className="hyttebokBox">
                        <h2>Husk å skrive i hytteboken!</h2>
                        <p>Derunder reparasjoner, innkjøp eller annet.</p>
                    </div>
                    <div className="infoBox">
                        Informasjon om eventuelle feil, insektplager som maur (eller kakerlakker), mangler, behov eller skader, eller gode ideer, sendes Siv.
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Huskeliste;
